import {
    CustomListItemId,
    InboundLeadClientType,
    InboundLeadStatusItem,
    resolveStartingStatus,
} from "@sp-crm/core";

export const UNKNOWN_STATUS = "Unknown status";

export interface StatusListItem extends InboundLeadStatusItem {
    name: string;
}

export interface StartingStatusDisplay {
    name: string;
    replacedBy: string | null;
}

const nameOf = (items: StatusListItem[], id: CustomListItemId | null): string =>
    items.find(item => item.id === id)?.name ?? UNKNOWN_STATUS;

export const startingStatusDisplay = (
    items: StatusListItem[],
    clientType: InboundLeadClientType,
    statusListItemId: CustomListItemId,
): StartingStatusDisplay => {
    const name = nameOf(items, statusListItemId);
    const starting = resolveStartingStatus(items, clientType, statusListItemId);
    if (!starting || starting === statusListItemId) {
        return { name, replacedBy: null };
    }
    return { name, replacedBy: nameOf(items, starting) };
};
